function initPdpGallery(sectionId) {
  var section = document.querySelector(
    '.pdp-gallery[data-gallery-id="' + sectionId + '"]'
  );

  if (!section) return;

  var lightbox = section.querySelector('.pdp-gallery__lightbox');
  if (!lightbox) return;

  var images = (window.PdpGalleryData && window.PdpGalleryData[sectionId]) || [];

  var track = section.querySelector('.pdp-gallery__track');
  var prevBtn = section.querySelector('.pdp-gallery__arrow--prev');
  var nextBtn = section.querySelector('.pdp-gallery__arrow--next');
  var thumbs = section.querySelectorAll('.pdp-gallery__thumb');

  var lbImg = lightbox.querySelector('.pdp-gallery__lightbox-img');
  var lbClose = lightbox.querySelector('.pdp-gallery__lightbox-close');
  var lbOverlay = lightbox.querySelector('.pdp-gallery__lightbox-overlay');
  var lbPrev = lightbox.querySelector('.pdp-gallery__lightbox-arrow--prev');
  var lbNext = lightbox.querySelector('.pdp-gallery__lightbox-arrow--next');
  var lbCounter = lightbox.querySelector('.pdp-gallery__lightbox-counter');

  var THUMB_WIDTH = 96 + 12;
  var currentSlide = 0;
  var currentImage = 0;
  var visibleCount = 0;

  /* ===========================
     Slider
  =========================== */

  function getVisibleCount() {
    var wrap = section.querySelector('.pdp-gallery__track-wrap');
    var wrapWidth = wrap.offsetWidth;
    return Math.max(1, Math.floor(wrapWidth / THUMB_WIDTH));
  }

  function updateSlider() {
    visibleCount = getVisibleCount();

    var maxSlide = Math.max(0, thumbs.length - visibleCount);
    currentSlide = Math.min(currentSlide, maxSlide);

    track.style.transform =
      'translateX(-' + currentSlide * THUMB_WIDTH + 'px)';

    prevBtn.disabled = currentSlide === 0;
    nextBtn.disabled = currentSlide >= maxSlide;
  }

  prevBtn.addEventListener('click', function () {
    currentSlide = Math.max(0, currentSlide - 1);
    updateSlider();
  });

  nextBtn.addEventListener('click', function () {
    var maxSlide = Math.max(0, thumbs.length - getVisibleCount());
    currentSlide = Math.min(maxSlide, currentSlide + 1);
    updateSlider();
  });

  window.addEventListener('resize', updateSlider);

  updateSlider();

  /* ===========================
     Lightbox
  =========================== */

  function showLightboxImage(index) {
    var imgData = images[index];
    if (!imgData) return;

    lbImg.classList.add('is-loading');

    lbImg.onload = function () {
      lbImg.classList.remove('is-loading');
    };

    lbImg.src = imgData.src;
    lbImg.alt = imgData.alt;

    lbCounter.textContent = index + 1 + ' / ' + images.length;

    lbPrev.disabled = index === 0;
    lbNext.disabled = index === images.length - 1;
  }

  function openLightbox(index) {
  currentImage = index;

  showLightboxImage(index);

  lightbox.classList.add('is-open');
  lightbox.setAttribute('aria-hidden', 'false');

  document.body.classList.add('custom_gallery_opened');
  document.body.style.overflow = 'hidden';

  lbClose.focus();
}

function closeLightbox() {
  lightbox.classList.remove('is-open');
  lightbox.setAttribute('aria-hidden', 'true');

  document.body.classList.remove('custom_gallery_opened');
  document.body.style.overflow = '';
}

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      openLightbox(parseInt(this.dataset.index, 10));
    });
  });

  lbClose.addEventListener('click', closeLightbox);
  lbOverlay.addEventListener('click', closeLightbox);

  lbPrev.addEventListener('click', function () {
    if (currentImage > 0) {
      currentImage--;
      showLightboxImage(currentImage);
    }
  });

  lbNext.addEventListener('click', function () {
    if (currentImage < images.length - 1) {
      currentImage++;
      showLightboxImage(currentImage);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (!lightbox.classList.contains('is-open')) return;

    if (e.key === 'Escape') {
      closeLightbox();
    }

    if (e.key === 'ArrowLeft' && currentImage > 0) {
      currentImage--;
      showLightboxImage(currentImage);
    }

    if (e.key === 'ArrowRight' && currentImage < images.length - 1) {
      currentImage++;
      showLightboxImage(currentImage);
    }
  });
}
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.pdp-gallery').forEach(function (gallery) {
    initPdpGallery(gallery.dataset.galleryId);
  });
});